// extracted by mini-css-extract-plugin
export var content = "InfoQueryCard-module--content--568f0";
export var icon = "InfoQueryCard-module--icon--84c72";
export var list = "InfoQueryCard-module--list--8f98d";
export var wrapper = "InfoQueryCard-module--wrapper--f197d";